import { AbstractControl } from '@angular/forms';

/**
 * Customized email validator
 */
export class EmailValidator {
  static validate(control: AbstractControl): { [key: string]: string } | null {
    if (!control.dirty) return null;

    const email = control.value;

    if (/\S+@\S+\.\S+/.test(email) && email.length < 320) return null;

    return { message: 'Email is invalid' };
  }
}
